import React from 'react';
import {Context} from '../context';
import {assetImgUrl} from '../helperFunctions';

export default function Welcome(props) {
  const {localeText, content} = React.useContext(Context);
  const {className} = props;

  return (
    <div className={`${className} flex gap-8 w-full`}>
      <div className='w-64 shrink-0 hidden md:inline-block xl:hidden 2xl:inline-block'>
        {assetImgUrl(content, 'phoneImage') && (
          <img
            src={assetImgUrl(content, 'phoneImage')}
            alt={localeText('rw_home_alt_phone', 'Phone')}
          />
        )}
      </div>
      <div className='grow'>
        <h1>{localeText('rw_home_header_welcome', 'Welcome')}</h1>
        <p>
          {localeText(
            'rw_home_welcome_paragraph',
            `Your phone is your ticket to ride! App is the best way to buy tickets directly on your smartphone.
            
            Download the App from the App Storeᵀᴹ or Google Playᵀᴹ. If you have a mobile account, use the same email and password to sign in to the web portal. Use this web portal to create and manage your account and register Transit Cards to your account.
            `
          )}
        </p>
        <div className='flex gap-4 my-8 justify-start max-w-md'>
          <a
            className='w-36 grow shrink'
            href='https://www.apple.com/app-store/'
            target='_blank'
            rel='noreferrer'
          >
            <img
              alt={localeText('rw_home_alt_itunes_link', 'Apple Store')}
              src='/images/common_store_apple.png'
            />
          </a>
          <a
            className='w-36 grow shrink'
            href='https://play.google.com/'
            target='_blank'
            rel='noreferrer'
          >
            <img
              alt={localeText('rw_home_alt_google_link', 'Google Play Store')}
              src='/images/common_store_google.png'
            />
          </a>
        </div>
        <hr />
      </div>
    </div>
  );
}
